module.exports = __webpack_public_path__ + "img/horizontal_4_1_8023.b9274b88.png";